import { render, staticRenderFns } from "./SelectedTagsAutocomplete.vue?vue&type=template&id=dc825d54&scoped=true"
import script from "./SelectedTagsAutocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedTagsAutocomplete.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectedTagsAutocomplete.vue?vue&type=style&index=0&id=dc825d54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc825d54",
  null
  
)

export default component.exports